// Views and conversions of inline offers, counted by the View Count plugin on the offer's entry id.
// A view is counted once per page load, when the offer scrolls into view. Conversions are counted
// server-side (InlineOfferTrackingService) from the offer id added to the submitted form here.

const VIEW_COUNT_URL = '/actions/view-count/increment';
const OFFER_ID_PARAM = 'inlineOfferId';

let viewObserver = null;
let submitListenerAdded = false;

function countView(offerId) {
  const data = new FormData();
  data.append('id', offerId);

  fetch(VIEW_COUNT_URL, {method: 'POST', body: data, credentials: 'same-origin'}).catch(() => {});
}

function getViewObserver() {
  if (!viewObserver) {
    // Count once the offer's top is a fifth of the screen above the bottom edge, whatever its height.
    viewObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        observer.unobserve(entry.target);
        countView(entry.target.dataset.inlineOfferId);
      });
    }, {rootMargin: '0px 0px -20% 0px'});
  }

  return viewObserver;
}

// Capture phase, so the field is in the form before Formie reads it for its AJAX request.
function addOfferIdOnSubmit(event) {
  const form = event.target;
  const offer = form.closest?.('[data-inline-offer-id]');
  if (!offer || !offer.dataset.inlineOfferId || form.querySelector(`input[name="${OFFER_ID_PARAM}"]`)) {
    return;
  }

  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = OFFER_ID_PARAM;
  input.value = offer.dataset.inlineOfferId;
  form.appendChild(input);
}

export function initInlineOfferTracking(root = document) {
  if (!submitListenerAdded) {
    document.addEventListener('submit', addOfferIdOnSubmit, true);
    submitListenerAdded = true;
  }

  if (!('IntersectionObserver' in window)) {
    return;
  }

  root.querySelectorAll('[data-inline-offer-id]').forEach((offer) => {
    if (!offer.dataset.inlineOfferId || offer.dataset.inlineOfferTracked === 'true') {
      return;
    }

    offer.dataset.inlineOfferTracked = 'true';
    getViewObserver().observe(offer);
  });
}
